import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class ExperimentPoster extends React.Component {
  componentWillMount() {
    this.props.createExperimentPoster({
      props: this.props.defaultProps,
    });
  }

  showPosterModal = () => {

    if(this.props.type === "Experimental setup poster"){
      this.props.setModal({
        type: 'EXPERIMENTAL_SETUP_POSTER',
        data: { altText: '4 tubes filled with green (pH 7) BTB solution and sealed with stoppers. Tubes 2 and 4 are in boxes. Tubes 3 and 4 each contain a water plant.' },
        size: 'cover'
      });
  
      this.props.showModal({display: true});
    }
  };

  render() {
    return (
      <ul>
        <li
          id={"ExperimentPoster_"+this.props.id}
          tabIndex={0}
          onClick={this.showPosterModal}
          className={'ExperimentPoster'}>
          <p aria-hidden="true" className="label">{this.props.type}</p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

ExperimentPoster.propTypes = {
  createExperimentPoster: PropTypes.func,
};

ExperimentPoster.defaultProps = {};
